import { FC } from "react";
import { Typography } from "@/components";
import { app_logo } from "@/constants";

interface LoadingMessageProps {
  steps?: string[];
  liveText?: string;
}

const LoadingMessage: FC<LoadingMessageProps> = ({ steps }) => {
  return (
    <div
      style={{
        marginBottom: 16,
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
        paddingLeft: "clamp(12px, 4vw, 40px)",
        gap: 12,
      }}
    >
      <div
        style={{
          position: "relative",
          width: 40,
          height: 40,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div
          style={{
            position: "absolute",
            width: 40,
            height: 40,
            borderRadius: "50%",
            border: "1.2px solid #333",
            opacity: 0,
            animation: "radar 3s infinite ease-out",
            animationDelay: "0s",
          }}
        />
        <div
          style={{
            position: "absolute",
            width: 40,
            height: 40,
            borderRadius: "50%",
            border: "1.2px solid #333",
            opacity: 0,
            animation: "radar 3s infinite ease-out",
            animationDelay: "0.75s",
          }}
        />
        <div
          style={{
            position: "absolute",
            width: 40,
            height: 40,
            borderRadius: "50%",
            border: "1.2px solid #333",
            opacity: 0,
            animation: "radar 3s infinite ease-out",
            animationDelay: "1.5s",
          }}
        />
        <div
          style={{
            position: "absolute",
            width: 40,
            height: 40,
            borderRadius: "50%",
            border: "1.2px solid #333",
            opacity: 0,
            animation: "radar 3s infinite ease-out",
            animationDelay: "2.25s",
          }}
        />
        <img 
          src={app_logo} 
          style={{ 
            width: 26, 
            height: 26, 
            filter: 'brightness(0)' 
          }} 
          alt="Loading..."
        />
      </div>
      <div style={{ marginLeft: 16, flex: 1 }}>
        {steps && steps.length > 0 ? (
          <div>
            {steps.slice(-1).map((step, idx) => (
              <Typography key={idx} variant="regular" fontSize={15} color="#333" display="block">
                {step}
              </Typography>
            ))}
          </div>
        ) : (
          <Typography
            variant="regular"
            fontSize={16}
            color="#666"
            style={{
              lineHeight: 1.6,
            }}
          >
            Working...
          </Typography>
        )}
      </div>
      <style>
        {`
          @keyframes radar {
            0% {
              transform: scale(1.2);
              opacity: 0;
            }
            10% {
              opacity: 1;
            }
            50% {
              opacity: 0.3;
            }
            70% {
              opacity: 0;
            }
            100% {
              transform: scale(2.5);
              opacity: 0;
            }
          }
        `}
      </style>
    </div>
  );
};

export default LoadingMessage;
